import ProgressCaption from '@frontend/jetlend-web-ui/src/ui/ProgressCaption/ProgressCaption';
import { useState } from 'react';
import { useOptionalInterval } from '@frontend/jetlend-core/src/hooks/useInterval';
import Loader from '@frontend/jetlend-web-ui/src/ui/loaders/Loader';
import { BorrowerLimitPrescoringStatusType } from '@app/models/borrowers/limitPrescoring';
import styles from './ScoringInProgress.module.scss';

export interface ProgressItem {
    /**
     * Текст заголовка
     */
    title: string;
    /**
     * Процент выполнения
     */
    from: number;
}

const progressItemsConfiguration: ProgressItem[] = [
    {
        title: 'Анализ данных ФНС',
        from: 0.25,
    },
    {
        title: 'Анализ данных Ресурс БФО',
        from: 0.5,
    },
    {
        title: 'Анализ данных Контур.Фокус',
        from: 0.75,
    },
    {
        title: 'Анализ данных ЕГР',
        from: 1,
    },
];

export interface Props {
    /**
     * Статус расчета лимита
     */
    status?: BorrowerLimitPrescoringStatusType;
    /**
     * Флаг отображения спиннера
     */
    isLoading?: boolean;
}

/**
 * Компонент отображает прогресс расчета лимита
 */
export default function ScoringInProgress({
    status,
    isLoading,
}: Props) {
    const [ progress, setProgress ] = useState(0);
    const isScoringOverdue = progress > 98.5;

    useOptionalInterval(() => {
        const newProgress = Math.min(progress + 1, 99);
        if (Math.abs(newProgress - progress) !== 0) {
            // Trigger rerendering only when progress changed
            setProgress(newProgress);
        }
    }, !isScoringOverdue, 1000, [ progress ]);

    return (
        <div className={styles['content']}>
            <h2 className={styles['title']} data-testid="limit-prescoring-modal__title">
                Расчет лимита
            </h2>
            {isLoading
                ? (
                    <Loader
                        size='normal'
                        className={styles['loader']}
                    />
                )
                : (
                    <div className={styles['progress-wrapper']}>
                        {progressItemsConfiguration.map(item => (
                            <ProgressCaption
                                key={item.title}
                                title={item.title}
                                loading={(progress * 0.01) < item.from}
                                completed
                                bordered
                            />
                        )
                        )}
                    </div>
                )}
        </div>
    );
}